// cart-upsell.js — tabbed Swiper carousels for bestsellers (empty) and upsells (active)
(function () {
  const drawer =
    document.querySelector('[data-pb-cart-drawer="primary"]') ||
    document.getElementById('UnifiedCartDrawer');
  if (!drawer) return;

  const bestsellersCard = document.getElementById('CartBestsellers');
  const bestsellersTabs = document.getElementById('CartBestsellersTabs');
  const bestsellersList = document.getElementById('CartBestsellersList');
  const bestsellersSplideEl = document.getElementById('CartBestsellersSplide');

  const upsellCard = document.getElementById('CartUpsellCard');
  const upsellTabs = document.getElementById('CartUpsellTabs');
  const upsellList = document.getElementById('CartUpsellList');
  const upsellSplideEl = document.getElementById('CartUpsellSplide');

  if (!bestsellersList || !upsellList) return;

  const collectionHandle = drawer.dataset.upsellCollection || '';
  const intent = drawer.dataset.upsellIntent || 'related';
  const limit = Number(drawer.dataset.upsellLimit || 8);

  const bestsellerCollection1 = drawer.dataset.bestsellerCollection1 || '';
  const bestsellerCollection2 = drawer.dataset.bestsellerCollection2 || '';
  const bestsellerTab1Label = drawer.dataset.bestsellerTab1Label || 'Tab 1';
  const bestsellerTab2Label = drawer.dataset.bestsellerTab2Label || 'Tab 2';

  const upsellTab1Label = drawer.dataset.upsellTab1Label || 'Relevant products';
  const upsellTab2Label = drawer.dataset.upsellTab2Label || 'Accessoires';

  let bestsellersSplide = null;
  let upsellSplide = null;
  let activeBestsellerTab = 'tab1';
  let activeUpsellTab = 'tab1';
  let initTimer = null;
  const recCache = new Map();

  function fmtEUR(cents) {
    const v = Math.max(0, Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(v);
    } catch {
      return '€' + v.toFixed(2).replace('.', ',');
    }
  }

  function priceToCents(raw) {
    if (typeof raw === 'string') {
      const n = parseFloat(raw.replace(',', '.'));
      return Number.isFinite(n) ? Math.round(n * 100) : 0;
    }
    const n = Number(raw);
    return Number.isFinite(n) ? n : 0;
  }

  function gidToNumericId(gid) {
    if (!gid) return '';
    const s = String(gid);
    if (/^\d+$/.test(s)) return s;
    const match = s.match(/\/(\d+)\s*$/);
    return match ? match[1] : s.replace(/\D/g, '');
  }

  function getImageSrc(product, variant) {
    return (
      variant?.featured_image?.src ||
      variant?.image?.src ||
      variant?.image ||
      product?.images?.[0]?.src ||
      product?.featured_image?.url ||
      product?.featured_image?.src ||
      product?.featured_image ||
      product?.image?.url ||
      product?.image?.src ||
      product?.image ||
      ''
    );
  }

  function destroySplide(instance) {
    if (instance) {
      try {
        instance.destroy(true, true);
      } catch (e) {
        /* ignore */
      }
    }
    return null;
  }

  const TITLE_MARQUEE_MQ = window.matchMedia('(max-height: 699px)');
  const REDUCED_MOTION_MQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  let titleMarqueeResizeTimer = null;

  // Short viewports nowrap the title; only loop when the text actually overflows
  // the card. Measure after layout — slides are off-screen until the drawer opens.
  function syncTitleMarquees(container) {
    if (!container) return;

    const wraps = container.querySelectorAll('.ucd-carousel-card__titlewrap');

    for (const wrap of wraps) {
      wrap.classList.remove('is-marquee');
      wrap.style.removeProperty('--ucd-titlewrap-marquee-duration');

      if (!TITLE_MARQUEE_MQ.matches || REDUCED_MOTION_MQ.matches) continue;

      const group = wrap.querySelector('.ucd-carousel-card__titlegroup:not([aria-hidden])');
      if (!group) continue;

      const wrapWidth = wrap.clientWidth;
      if (wrapWidth < 8) continue;

      // Title + subtitle sit on one row at short height; measure the full group.
      const contentWidth = group.scrollWidth;
      if (contentWidth <= wrapWidth + 1) continue;

      wrap.classList.add('is-marquee');
      wrap.style.setProperty(
        '--ucd-titlewrap-marquee-duration',
        `${Math.max(6, contentWidth / 32)}s`
      );
    }
  }

  function refreshTitleMarquees() {
    syncTitleMarquees(bestsellersList);
    syncTitleMarquees(upsellList);
  }

  function scheduleTitleMarqueeRefresh() {
    if (titleMarqueeResizeTimer) clearTimeout(titleMarqueeResizeTimer);
    titleMarqueeResizeTimer = setTimeout(refreshTitleMarquees, 100);
  }

  TITLE_MARQUEE_MQ.addEventListener('change', refreshTitleMarquees);
  REDUCED_MOTION_MQ.addEventListener('change', refreshTitleMarquees);
  window.addEventListener('resize', scheduleTitleMarqueeRefresh);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(refreshTitleMarquees);
  }

  function refreshSplideLayout(instance, el) {
    if (!instance || !el) return;

    const run = () => {
      try {
        instance.update();
        if (typeof instance.updateSize === 'function') instance.updateSize();
        if (typeof instance.updateAutoHeight === 'function') instance.updateAutoHeight();
        // Swiper can leave a stale inline height on iOS WebKit.
        el.style.height = '';
        const wrapper = el.querySelector('.swiper-wrapper');
        if (wrapper) wrapper.style.height = '';
      } catch (e) {
        /* ignore */
      }

      el.querySelectorAll('.ucd-carousel-card__overlay').forEach((node) => {
        node.style.transform = 'translateZ(0)';
      });

      syncTitleMarquees(el);
    };

    requestAnimationFrame(() => {
      run();
      requestAnimationFrame(run);
    });
  }

  // Mount a Swiper carousel. Swiper's bullet pagination is snap-point based, so
  // it respects `slidesPerGroup` (move 2) and the end clamp natively — each dot
  // maps to a real, reachable scroll position (no dead/duplicate dots).
  //
  // Slide widths come from CSS via slidesPerView:'auto' (3 cards desktop, 2.5
  // mobile). The container is full-bleed (negative margins in CSS match the
  // content padding); slidesOffsetBefore/After re-add the start/end gaps so the
  // first card aligns with the content and there's breathing room after the last.
  function mountSplide(el, listEl) {
    if (!el || !listEl || typeof Swiper === 'undefined') return null;
    if (!listEl.children.length) return null;

    const paginationEl = el.querySelector('.swiper-pagination');

    const instance = new Swiper(el, {
      slidesPerView: 'auto',
      slidesPerGroup: 2,
      spaceBetween: 12,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      autoHeight: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      speed: 400,
      pagination: paginationEl
        ? { el: paginationEl, clickable: true }
        : false,
      breakpoints: {
        769: {
          slidesOffsetBefore: 26,
          slidesOffsetAfter: 26
        }
      }
    });

    refreshSplideLayout(instance, el);

    return instance;
  }

  // `source`/`context` are written to the cart line as line-item attributes, so the
  // attribution survives into the order (same mechanism as _free_gift / _pick_mix)
  // and can be joined with the Converge ATC events downstream.
  async function addToCart(variantId, source, context) {
    if (!window.PBCart) throw new Error('PBCart not loaded');

    const attributes = source
      ? [
          { key: '_added_via', value: String(source) },
          { key: '_added_via_context', value: String(context || '') }
        ]
      : [];

    const cart = await window.PBCart.addLine(variantId, 1, attributes);
    document.dispatchEvent(new CustomEvent('pb:cart:updated', { detail: { cart } }));
    return cart;
  }

  function resolveUpsellCardTitle(product) {
    const nativeTitle = String(product?.title || '').trim();
    const cardTitle = String(product?.card_title || '').trim();
    const ratingFor = String(product?.rating_for || '').trim();
    const naming = String(product?.cart_naming || '').trim().toLowerCase();

    switch (naming) {
      case 'bar':
        return ratingFor || nativeTitle;
      case 'accessoire':
      case 'skincare':
      case 'bundle':
      case 'liquid':
      case 'powr':
        return cardTitle || nativeTitle;
      default:
        return cardTitle || nativeTitle;
    }
  }

  /** Bar products only — mirrors cart line subtitle for custom.cart_naming = bar. */
  function resolveUpsellCardSubtitle(product) {
    const naming = String(product?.cart_naming || '').trim().toLowerCase();
    if (naming !== 'bar') return '';

    return String(product?.subtitle || '').trim();
  }

  // `meta` = { source, context } — drives both the Converge ATC attribution
  // (data-cvg-atc + data-atc-source/context, read by the tracker in theme.liquid)
  // and the line-item attributes written by addToCart().
  function slideHTML(product, meta) {
    const atcSource = meta?.source || '';
    const atcContext = meta?.context || '';
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const initVariant =
      variants.find((v) => v && v.available !== false) || variants[0] || {};

    const img = getImageSrc(product, initVariant);
    const priceCents = priceToCents(initVariant?.price || 0);
    const compareCents = priceToCents(
      initVariant?.compare_at_price || initVariant?.compareAtPrice || 0
    );
    const showCompare = compareCents > priceCents;

    const variantId = initVariant?.id || '';
    const cardTitle = resolveUpsellCardTitle(product);
    const cardSubtitle = resolveUpsellCardSubtitle(product);
    const titleGroupInner = `
              <h4 class="ucd-carousel-card__title">${cardTitle}</h4>
              ${cardSubtitle ? `<p class="ucd-carousel-card__subtitle">${cardSubtitle}</p>` : ''}
    `;

    return `
      <div class="swiper-slide">
        <article class="ucd-carousel-card" data-id="${product.id}">
          <div class="ucd-carousel-card__media">
            ${img ? `<img src="${img}" alt="${cardTitle}" loading="lazy">` : ''}
            <div class="ucd-carousel-card__overlay">
              <div class="ucd-carousel-card__prices">
                ${showCompare ? `<span class="ucd-carousel-card__compare">${fmtEUR(compareCents)}</span>` : ''}
                <span class="ucd-carousel-card__price">${fmtEUR(priceCents)}</span>
              </div>
              <button
                type="button"
                class="ucd-carousel-card__add"
                data-variant-id="${variantId}"
                data-cvg-atc
                data-atc-source="${atcSource}"
                data-atc-context="${atcContext}"
                aria-label="Add ${cardTitle || 'product'} to cart"
              >+</button>
            </div>
          </div>
          <div class="ucd-carousel-card__titlewrap">
            <div class="ucd-carousel-card__titletrack">
              <div class="ucd-carousel-card__titlegroup">${titleGroupInner}</div>
              <div class="ucd-carousel-card__titlegroup" aria-hidden="true">${titleGroupInner}</div>
            </div>
          </div>
        </article>
      </div>
    `;
  }

  function bindAddButtons(container) {
    if (!container) return;

    container.querySelectorAll('.ucd-carousel-card__add').forEach((btn) => {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', async () => {
        const vid = btn.dataset.variantId;
        if (!vid) return;

        const source = btn.dataset.atcSource || '';
        const context = btn.dataset.atcContext || '';

        btn.classList.add('is-loading');
        btn.disabled = true;

        try {
          await addToCart(vid, source, context);
          btn.textContent = '✓';
          setTimeout(() => {
            btn.textContent = '+';
          }, 700);
        } catch (e) {
          btn.textContent = '!';
          setTimeout(() => {
            btn.textContent = '+';
          }, 1200);
        } finally {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        }
      });
    });
  }

  function renderSlides(listEl, products, splideEl, splideRef, meta) {
    // Mix & match packs can't be added without a colour choice (same rule as the
    // product cards' quick add), so they never show up in these carousels.
    const filtered = (products || []).filter((p) => p && p.id && !p.is_mixmatch);

    if (!filtered.length) {
      listEl.innerHTML = `<div class="swiper-slide"><p class="ucd-carousel-empty">Geen aanbevelingen beschikbaar.</p></div>`;
      splideRef = destroySplide(splideRef);
      return splideRef;
    }

    listEl.innerHTML = filtered
      .slice(0, limit)
      .map((p) => slideHTML(p, meta))
      .join('');
    bindAddButtons(listEl);

    splideRef = destroySplide(splideRef);
    splideRef = mountSplide(splideEl, listEl);
    return splideRef;
  }

  function buildTabs(container, tabs, activeId, onSelect) {
    if (!container) return;

    container.innerHTML = tabs
      .map(
        (tab) => `
      <button
        type="button"
        class="ucd-carousel-tab${tab.id === activeId ? ' is-active' : ''}"
        role="tab"
        aria-selected="${tab.id === activeId ? 'true' : 'false'}"
        data-tab-id="${tab.id}"
      >${tab.label}</button>
    `
      )
      .join('');

    container.querySelectorAll('.ucd-carousel-tab').forEach((btn) => {
      btn.addEventListener('click', () => {
        const tabId = btn.dataset.tabId;
        if (!tabId || tabId === activeId) return;
        onSelect(tabId);
      });
    });
  }

  // Fetch a larger pool than we display so that when an upsell product is added
  // to the cart (and filtered out), the next not-in-cart product from the same
  // collection backfills the freed slot. renderSlides() slices down to `limit`.
  const COLLECTION_POOL = 50;
  function fetchCollection(handle) {
    if (!handle) return Promise.resolve([]);
    const poolSize = Math.min(250, Math.max(COLLECTION_POOL, limit * 4));
    return fetch(`/collections/${handle}/products.json?limit=${encodeURIComponent(poolSize)}`)
      .then((r) => r.json())
      .then((d) => d.products || [])
      .catch(() => []);
  }

  function readEmbeddedProducts(scriptId) {
    const script = document.getElementById(scriptId);
    if (!script) return [];

    try {
      const products = JSON.parse(script.textContent || '[]');
      return Array.isArray(products) ? products : [];
    } catch (e) {
      return [];
    }
  }

  function fetchRecommendations(productId) {
    if (!productId) return Promise.resolve([]);
    if (recCache.has(productId)) return recCache.get(productId);

    const url = `/recommendations/products.json?product_id=${productId}&limit=${Math.max(4, limit)}&intent=${intent}`;
    const p = fetch(url)
      .then((r) => r.json())
      .then((d) => d.products || [])
      .catch(() => []);
    recCache.set(productId, p);
    return p;
  }

  function clearRecCache() {
    recCache.clear();
  }

  // Collection/recommendation JSON endpoints don't return custom metafields, so
  // resolve cart_naming-driven titles via the Storefront API (mirrors cart items).
  const cardTitleCache = new Map(); // gid -> { card_title, rating_for, cart_naming, subtitle }
  async function resolveCardTitles(products) {
    const cfg = window.PB_UNIFIED_CART || {};
    if (!cfg.endpoint || !cfg.token) return products;

    const pending = new Map(); // gid -> product
    for (const p of products || []) {
      if (!p || p._namingResolved) continue;
      const numeric = gidToNumericId(p.id);
      if (!numeric) continue;
      const gid = `gid://shopify/Product/${numeric}`;
      if (cardTitleCache.has(gid)) {
        const cached = cardTitleCache.get(gid) || {};
        if (cached.card_title) p.card_title = cached.card_title;
        if (cached.rating_for) p.rating_for = cached.rating_for;
        if (cached.cart_naming) p.cart_naming = cached.cart_naming;
        if (cached.subtitle) p.subtitle = cached.subtitle;
        if (cached.is_mixmatch) p.is_mixmatch = true;
        continue;
      }
      pending.set(gid, p);
    }

    if (!pending.size) return products;

    const query =
      'query($ids:[ID!]!){nodes(ids:$ids){... on Product{id title ' +
      'cardTitle: metafield(namespace:"custom",key:"product_card_title"){value} ' +
      'productSubtitle: metafield(namespace:"custom",key:"product_subtitle"){value} ' +
      'ratingFor: metafield(namespace:"custom",key:"collection_page_rating_for"){value} ' +
      'cartNaming: metafield(namespace:"custom",key:"cart_naming"){value} ' +
      'mixmatchColors: metafield(namespace:"custom",key:"mixmatch_colors"){value}}}}';

    try {
      const res = await fetch(cfg.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': cfg.token
        },
        body: JSON.stringify({ query, variables: { ids: [...pending.keys()] } })
      });
      const json = await res.json();
      const nodes = json?.data?.nodes || [];
      for (const node of nodes) {
        if (!node || !node.id) continue;
        const cardTitle = node.cardTitle?.value || '';
        const subtitle = node.productSubtitle?.value || '';
        const ratingFor = node.ratingFor?.value || '';
        const cartNaming = node.cartNaming?.value || '';
        const isMixmatch = Boolean(node.mixmatchColors?.value);
        cardTitleCache.set(node.id, {
          card_title: cardTitle,
          subtitle,
          rating_for: ratingFor,
          cart_naming: cartNaming,
          is_mixmatch: isMixmatch
        });
        const p = pending.get(node.id);
        if (p) {
          if (isMixmatch) p.is_mixmatch = true;
          if (cardTitle) p.card_title = cardTitle;
          if (subtitle) p.subtitle = subtitle;
          if (ratingFor) p.rating_for = ratingFor;
          if (cartNaming) p.cart_naming = cartNaming;
          if (!p.title && node.title) p.title = node.title;
        }
      }
    } catch (e) {
      /* ignore — fall back to product.title */
    }

    return products;
  }

  async function fetchPBCartProductIds() {
    if (!window.PBCart || typeof window.PBCart.current !== 'function') {
      return [];
    }

    const cart = await window.PBCart.current();
    const lines = (cart?.lines?.edges || []).map((edge) => edge.node);
    const ids = [];

    for (const line of lines) {
      const productGid = line?.merchandise?.product?.id;
      const numericId = gidToNumericId(productGid);
      if (numericId) ids.push(numericId);
    }

    return [...new Set(ids)];
  }

  function uniqueById(items) {
    const seen = new Set();
    const out = [];

    for (const p of items) {
      if (!p || !p.id || seen.has(p.id)) continue;
      seen.add(p.id);
      out.push(p);
    }

    return out;
  }

  // Remove any product that is already in the cart from an upsell list.
  async function filterOutInCart(products) {
    const list = products || [];
    if (!list.length) return list;
    const productIds = await fetchPBCartProductIds();
    if (!productIds.length) return list;
    const inCartIds = new Set(productIds.map((id) => String(id)));
    return list.filter((p) => p && !inCartIds.has(String(gidToNumericId(p.id))));
  }

  async function loadFromRecommendations() {
    const productIds = await fetchPBCartProductIds();
    const inCartIds = new Set(productIds.map((id) => Number(id)));

    if (!productIds.length) {
      if (collectionHandle) return fetchCollection(collectionHandle);
      return [];
    }

    const batches = productIds.map((id) => fetchRecommendations(id));
    const all = (await Promise.all(batches)).flat();

    const filtered = uniqueById(
      all.filter((p) => !inCartIds.has(p.id) && p.available !== false)
    );

    if (!filtered.length && collectionHandle) {
      return fetchCollection(collectionHandle);
    }

    return filtered;
  }

  async function isCartEmpty() {
    if (!window.PBCart || typeof window.PBCart.current !== 'function') {
      return true;
    }

    const cart = await window.PBCart.current();
    const qty = Number(cart?.totalQuantity || 0);
    const edges = cart?.lines?.edges || [];
    return qty === 0 || edges.length === 0;
  }

  async function waitForPBCart(maxMs = 5000) {
    const start = Date.now();
    while (!(window.PBCart && typeof window.PBCart.current === 'function')) {
      if (Date.now() - start > maxMs) return false;
      await new Promise((r) => setTimeout(r, 50));
    }
    return true;
  }

  function setMode(empty) {
    if (bestsellersCard) bestsellersCard.hidden = !empty;
    if (upsellCard) {
      upsellCard.hidden = empty;
      upsellCard.classList.toggle('is-sticky', !empty);
    }
    // Keep the empty-state class in sync here too (independent of the progress bar)
    drawer.classList.toggle('ucd-cart-empty', empty);
  }

  // Swiper measures slide widths at mount time. The drawer is rendered off-screen,
  // so on mobile those measurements can be wrong until it is visible. Recalculate
  // whenever the drawer opens.
  function refreshVisibleSplide() {
    requestAnimationFrame(() => {
      refreshSplideLayout(bestsellersSplide, bestsellersSplideEl);
      refreshSplideLayout(upsellSplide, upsellSplideEl);
    });
  }

  const openObserver = new MutationObserver(() => {
    if (drawer.classList.contains('is-open')) refreshVisibleSplide();
  });
  openObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('cart:open', refreshVisibleSplide);

  async function renderBestsellers(tabId) {
    activeBestsellerTab = tabId;

    const tabs = [
      { id: 'tab1', label: bestsellerTab1Label, handle: bestsellerCollection1 },
      { id: 'tab2', label: bestsellerTab2Label, handle: bestsellerCollection2 }
    ];

    buildTabs(bestsellersTabs, tabs, activeBestsellerTab, renderBestsellers);

    const active = tabs.find((t) => t.id === activeBestsellerTab) || tabs[0];
    const embeddedProducts = readEmbeddedProducts(
      activeBestsellerTab === 'tab1' ? 'CartBestsellerData1' : 'CartBestsellerData2'
    );
    const products = embeddedProducts.length
      ? embeddedProducts
      : await fetchCollection(active.handle);
    await resolveCardTitles(products);
    bestsellersSplide = renderSlides(
      bestsellersList,
      products,
      bestsellersSplideEl,
      bestsellersSplide,
      { source: 'cart_bestsellers', context: active.id }
    );
  }

  async function renderUpsell(tabId) {
    activeUpsellTab = tabId;

    const tabs = [
      { id: 'tab1', label: upsellTab1Label },
      { id: 'tab2', label: upsellTab2Label }
    ];

    buildTabs(upsellTabs, tabs, activeUpsellTab, renderUpsell);

    let products = [];

    if (activeUpsellTab === 'tab1') {
      products = await loadFromRecommendations();
    } else {
      products = await fetchCollection(collectionHandle);
    }

    products = await filterOutInCart(products);
    // Resolve before slicing so a hidden mix & match pack frees its slot for the next product.
    await resolveCardTitles(products);
    products = products.filter((p) => p && !p.is_mixmatch).slice(0, limit);
    upsellSplide = renderSlides(upsellList, products, upsellSplideEl, upsellSplide, {
      source: 'cart_upsell',
      context: activeUpsellTab === 'tab1' ? 'recommendations' : 'accessories'
    });
  }

  async function init() {
    await waitForPBCart();
    const empty = await isCartEmpty();
    setMode(empty);

    if (empty) {
      upsellSplide = destroySplide(upsellSplide);
      if (upsellList) upsellList.innerHTML = '';
      await renderBestsellers(activeBestsellerTab);
      return;
    }

    bestsellersSplide = destroySplide(bestsellersSplide);
    if (bestsellersList) bestsellersList.innerHTML = '';
    await renderUpsell(activeUpsellTab);
  }

  function scheduleInit() {
    clearRecCache();
    if (initTimer) clearTimeout(initTimer);
    initTimer = setTimeout(init, 150);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('pb:cart:updated', scheduleInit);
  document.addEventListener('cart:updated', scheduleInit);
})();
